import { CSRF_TOKEN } from "@pages/csrf";
import { useEffect, useRef } from "react";

export function useViewThread(threadId: string) {
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  function registerViewer() {
    fetch(`/messages/${threadId}/viewer/`, {
      method: "POST",
      headers: {
        "X-CSRFToken": CSRF_TOKEN,
        "Content-Type": "application/json",
      },
    });
  }

  function unregisterViewer() {
    fetch(`/messages/${threadId}/viewer/`, {
      method: "DELETE",
      headers: {
        "X-CSRFToken": CSRF_TOKEN,
      },
    });
  }

  useEffect(() => {
    registerViewer();
    intervalRef.current = setInterval(registerViewer, 5000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      unregisterViewer();
    };
  }, [threadId]);

  return null;
}
